/* globals gtag */

import React, { useState, useCallback, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  SetActiveFilters,
  SetUrlPrefix,
  SetImgPrefix,
  SetSliderValueMinMax,
  SetIsExpanded,
  SetIsSearching,
  SetSliderValue,
  SetSearchWord,
  SetAsyncData,
  SetListingBanner,
  SetPrevProducts,
  SetProducts,
  SetFilters,
  SetResultsCount,
  SetMasterCategories,
  SetPages,
  SetPage,
  SetSuggestedWords,
} from "../../state/actions/index"
import "./BarcodeReader.css"
import BarcodeScannerComponent from "react-webcam-barcode-scanner"
import Utils from "../../utils/Utils"
import axios from "axios"

const BarcodeReader = () => {
  const configFilters = useSelector((state) => state.config.filters)
  const card = useSelector((state) => state.config.card)
  const baseUrl = useSelector((state) => state.config.baseUrl)
  const sliderValue = useSelector((state) => state.sliderValue)
  const sliderValueMinMax = useSelector((state) => state.sliderValueMinMax)
  const config = useSelector((state) => state.config)
  const defaultMasterCategories = useSelector(
    (state) => state.defaultMasterCategories
  )
  const sort = useSelector((state) => state.sort)
  const isMobile = useSelector((state) => state.isMobile)
  const products = useSelector((state) => state.products)
  const accentColor = useSelector((state) => state.config.accentColor)
  const shopId = useSelector((state) => state.config.shopId)
  const ga4 = useSelector((state) => state.config.ga4)
  const dispatch = useDispatch()
  const [scanning, setScanning] = useState(false)

  const categoryKey = useMemo(() => {
    var valueToReturn = ""
    Object.keys(configFilters).forEach((filter) => {
      if (configFilters[filter].isCategory) valueToReturn = filter
    })
    return valueToReturn
  }, [configFilters])

  const queryOptions = useSelector((state) => state.config.queryOptions)
  var rows = useMemo(
    () => (isMobile ? queryOptions.rows.mobile : queryOptions.rows.desktop),
    [isMobile, queryOptions]
  )

  const onUpdate = useCallback(
    (err, result) => {
      if (result) {
        setScanning(false)
        dispatch(SetSearchWord(result.text))
        dispatch(SetActiveFilters([]))
        dispatch(SetIsSearching(true))
        dispatch(SetAsyncData([]))
        var priceGroup = {}
        priceGroup.id =
          window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
            ? window.AS_ADVANCED_CONFIG.visitorType
            : config.priceGroup.id
        priceGroup.currency =
          window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
            ? window.AS_ADVANCED_CONFIG.currencyCode
            : config.priceGroup.currency
        var localSearchUrl = Utils.getSearchUrl(
          config.baseUrl,
          config.queryOptions,
          priceGroup,
          config.shopId,
          config.jsonFast
        )
        axios
          .get(
            Utils.insertWordInSearchUrl(
              localSearchUrl,
              result.text,
              [],
              sort,
              1,
              configFilters,
              rows
            )
          )
          .then((res) => {
            Utils.sendAnalyticsObject(baseUrl, shopId, "as_success_barcode")
            if (!!ga4?.isActive) {
              if (
                typeof window.dataLayer !== "undefined" &&
                !!window.dataLayer
              ) {
                window.dataLayer.push({
                  event: "as_success_barcode",
                  data: {},
                })
              } else if (typeof gtag !== "undefined") {
                gtag("event", "as_success_barcode", {})
              }
            }
            var response = res.data
            dispatch(SetIsExpanded({}))
            dispatch(SetPrevProducts(products))
            dispatch(
              SetProducts(
                Utils.refactorUrl(
                  response.data,
                  response.header.imagePrefix,
                  response.header.urlPrefix,
                  card.img,
                  card.url
                )
              )
            )
            dispatch(SetSuggestedWords(response.suggestions))
            dispatch(SetResultsCount(response.header.results_count))
            dispatch(
              SetSliderValue(Utils.addSliderValue(response, sliderValue))
            )
            dispatch(
              SetSliderValueMinMax(
                Utils.addSliderValue(response, sliderValueMinMax)
              )
            )
            dispatch(SetFilters(response))
            dispatch(
              SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
            )
            dispatch(SetPage(1))
            dispatch(SetListingBanner(response.banners[0]))
            dispatch(
              SetMasterCategories(
                response.stats[categoryKey]
                  ? Utils.refactorMasterCategories(
                      Object.keys(response.stats[categoryKey])
                    )
                  : defaultMasterCategories
              )
            )
            dispatch(SetUrlPrefix(response.header.urlPrefix))
            dispatch(SetImgPrefix(response.header.imagePrefix))
            if (config.webhook.key !== "")
              Utils.getAsyncData(
                config.webhook,
                response.data,
                priceGroup
              ).then((value) => dispatch(SetAsyncData(value.asyncData)))
          })
          .finally(() => dispatch(SetIsSearching(false)))
      }
    },
    [
      dispatch,
      defaultMasterCategories,
      shopId,
      sort,
      rows,
      baseUrl,
      sliderValue,
      sliderValueMinMax,
      config,
      configFilters,
      products,
      categoryKey,
      card,
      setScanning,
    ]
  )

  return (
    <div className="barcode-container">
      {scanning ? (
        <div
          className="close"
          onClick={() => {
            setScanning(false)
            Utils.sendAnalyticsObject(baseUrl, shopId, "as_close_barcode")
            if (!!ga4?.isActive) {
              if (
                typeof window.dataLayer !== "undefined" &&
                !!window.dataLayer
              ) {
                window.dataLayer.push({ event: "as_close_barcode", data: {} })
              } else if (typeof gtag !== "undefined") {
                gtag("event", "as_close_barcode", {})
              }
            }
          }}
        ></div>
      ) : null}
      <div
        className="barcode-button"
        onClick={() => {
          setScanning(true)
          Utils.sendAnalyticsObject(baseUrl, shopId, "as_open_barcode")
          if (!!ga4?.isActive) {
            if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
              window.dataLayer.push({ event: "as_open_barcode", data: {} })
            } else if (typeof gtag !== "undefined") {
              gtag("event", "as_open_barcode", {})
            }
          }
        }}
      >
        <svg
          width="100%"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <title> Group 3</title>
          <desc> Created with Sketch.</desc>
          <g fill="none">
            <polygon points="0 0 24 0 24 24 0 24" />
            <g style={{ fill: accentColor }}>
              <path d="M6.4 5.1C6.7 5.1 7 5.4 7 5.8L7 5.8 7 17.4C7 17.8 6.7 18.1 6.4 18.1 6 18.1 5.7 17.8 5.7 17.4L5.7 17.4 5.7 5.8C5.7 5.4 6 5.1 6.4 5.1ZM11 5.1C11.3 5.1 11.6 5.4 11.6 5.7L11.6 5.7 11.6 17.5C11.6 17.8 11.3 18.1 11 18.1L11 18.1 9.1 18.1C8.7 18.1 8.5 17.8 8.5 17.5L8.5 17.5 8.5 5.7C8.5 5.4 8.7 5.1 9.1 5.1L9.1 5.1ZM13.7 5.1C14 5.1 14.3 5.4 14.3 5.8L14.3 5.8 14.3 17.4C14.3 17.8 14 18.1 13.7 18.1 13.3 18.1 13.1 17.8 13.1 17.4L13.1 17.4 13.1 5.8C13.1 5.4 13.3 5.1 13.7 5.1ZM16.4 5.1C16.8 5.1 17 5.4 17 5.8L17 5.8 17 17.4C17 17.8 16.8 18.1 16.4 18.1 16.1 18.1 15.8 17.8 15.8 17.4L15.8 17.4 15.8 5.8C15.8 5.4 16.1 5.1 16.4 5.1ZM20.5 5.1C20.8 5.1 21.1 5.4 21.1 5.7L21.1 5.7 21.1 17.5C21.1 17.8 20.8 18.1 20.5 18.1L20.5 18.1 19.1 18.1C18.8 18.1 18.5 17.8 18.5 17.5L18.5 17.5 18.5 5.7C18.5 5.4 18.8 5.1 19.1 5.1L19.1 5.1ZM3.7 5.1C4 5.1 4.3 5.4 4.3 5.7L4.3 5.7 4.3 17.5C4.3 17.8 4 18.1 3.7 18.1L3.7 18.1 2.7 18.1C2.4 18.1 2.1 17.8 2.1 17.5L2.1 17.5 2.1 5.7C2.1 5.4 2.4 5.1 2.7 5.1L2.7 5.1Z" />
            </g>
          </g>
        </svg>
      </div>
      {scanning ? (
        <div className="scanner">
          <BarcodeScannerComponent
            onUpdate={(err, result) => {
              onUpdate(err, result)
            }}
          />
        </div>
      ) : null}
    </div>
  )
}

export default BarcodeReader
